import { KVNavyAnnotation } from 'types'

import { KVRooftopAnnotation } from './KVRooftopAnnotation'

export class KVAnnotation {
  id: string
  label: string
  notes: string
  severity: string
  type: string
  visible: boolean
  position: string
  normal: string
  imageExport: boolean
  imageExportFilename: string | null
  userName: string
  userEmail: string

  // Custom-optional forms
  navyAnnotation?: KVNavyAnnotation
  rooftopAnnotation?: KVRooftopAnnotation

  constructor(id: string) {
    this.id = id
    this.label = ''
    this.notes = ''
    this.severity = '3'
    this.type = 'Misc.'
    this.visible = true
    this.position = ''
    this.normal = ''
    this.imageExport = false
    this.imageExportFilename = null
    this.userName = ''
    this.userEmail = ''
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  static fromJSON(json: any): KVAnnotation {
    const annotation = new KVAnnotation(json.annotationId)
    if (json.annotationLabel) annotation.label = json.annotationLabel
    if (json.annotationNotes) annotation.notes = json.annotationNotes
    if (json.annotationSeverity) annotation.severity = json.annotationSeverity
    if (json.annotationType) annotation.type = json.annotationType
    if (json.annotationVisible !== undefined)
      annotation.visible = json.annotationVisible
    if (json.annotationPosition) annotation.position = json.annotationPosition
    if (json.annotationNormal) annotation.normal = json.annotationNormal
    if (json.annotationImageExport !== undefined)
      annotation.imageExport = json.exportImage
    if (json.annotationImageFilename)
      annotation.imageExportFilename = json.annotationExportImageFilename
    if (json.navyAnnotation)
      annotation.navyAnnotation = KVNavyAnnotation.fromJSON(json.navyAnnotation)
    if (json.rooftopAnnotation)
      annotation.rooftopAnnotation = KVRooftopAnnotation.fromJSON(
        json.rooftopAnnotation
      )
    if (json.userName) annotation.userName = json.userName
    if (json.userEmail) annotation.userEmail = json.userEmail
    return annotation
  }

  static toJSON(annotation: KVAnnotation): any {
    // Create base fields in json
    const json: any = {
      annotationId: annotation.id,
      annotationLabel: annotation.label,
      annotationNotes: annotation.notes,
      annotationSeverity: annotation.severity,
      annotationVisible: annotation.visible,
      annotationPosition: annotation.position,
      annotationNormal: annotation.normal,
      annotationImageExport: annotation.imageExport,
      annotationImageFilename: annotation.imageExportFilename,
      userName: annotation.userName,
      userEmail: annotation.userEmail,
    }
    // Add custom-optional forms
    if (annotation.navyAnnotation) {
      json.navyAnnotation = KVNavyAnnotation.toJSON(annotation.navyAnnotation)
    }
    if (annotation.rooftopAnnotation) {
      json.rooftopAnnotation = KVRooftopAnnotation.toJSON(
        annotation.rooftopAnnotation
      )
    }
    return json
  }
}
